import React, { useState, useEffect, useRef, Fragment, useMemo } from "react";
import { useStripe, useElements, CardElement } from "@stripe/react-stripe-js";
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import Button from '@material-ui/core/Button';
import classnames from 'classnames'
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { withSnackbar } from 'notistack';
import Divider from '@material-ui/core/Divider'
import { useDispatch } from 'react-redux'
import { signIn, signUp } from '../../store/actions/authenticationActions'
import { addAllcalMemberToCalendarWithDashboardRole, addMember, getRegistrationCalendarAndAssociatedRole, logInvitedMember, notifyOrganizer, saveAnswers, subscribe, subscribeWithBankToken, welcomeUser } from '../../store/actions/membershipActions'
import { updateInfoForPaperMember } from "../../store/actions/accountActions";
import { embeddedUrl } from "../../store/actions/waiverActions";
import { getLinkAccountToken } from '../../store/actions/accountActions'
import LinkAccountButton from '../ui/linkAccountButton';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import { CircularProgress } from "@material-ui/core";
import moment from 'moment-timezone'
import { constants } from '../../App.constants'

const styles = (theme) => ({
    padding2: {
        padding: theme.spacing(2)
    },
    padding3: {
        padding: theme.spacing(3)
    },
    playerContainer: {
        marginTop: theme.spacing(2)
    },
    marginTop3: {
        marginTop: theme.spacing(3)
    },
    marginTop8: {
        marginTop: theme.spacing(8)
    },
    marginTop5: {

        marginTop: theme.spacing(5)
    },
    button: {
        paddingRight: theme.spacing(4),
        paddingLeft: theme.spacing(4),
        letterSpacing: '1px',
        '&:focus, &:hover, &:visited, &:link, &:active': {
            background: 'transparent'
        }
    },
    buttonPay: {
        '&:focus, &:hover, &:visited, &:link, &:active': {
            background: theme.palette.primary.main
        }
    },
    buttonCustomDashed: {
        color: '#009BE1',
        background: 'white',
        fontWeight: 600,
        border: '2px dashed #009BE1'

    },
    marginBottom2: {
        marginBottom: theme.spacing(3)
    },
    marginBottom1: {
        marginBottom: theme.spacing(1)
    },
    bold: {
        fontWeight: '600'
    },
    muted: {
        color: theme.palette.text.disabled
    },
    bgTransparent: {
        backgroundColor: 'transparent'
    },
    smallText: {
        fontSize: theme.spacing(1.75)
    },
    center: {
        textAlign: 'center'
    },
    subText: {
        fontWeight: 500,
        paddingLeft: theme.spacing(2)
    },
    header: {
        marginBottom: theme.spacing(3),
        fontWeight: 500,
        color: 'grey'
    },
    datePicker: {
        background: theme.palette.background.default,
        height: '60px',
        paddingLeft: '12px'
    },

    bgDefault: {
        background: theme.palette.primary.paper
    },
    error: {
        color: 'indianred'
    },
    link: {
        color: theme.palette.primary.main + ' !important',
        cursor: 'pointer'
    },
    headerDiv: {
        fontSize: '18px',
        fontWeight: 600,
        marginBottom: theme.spacing(1)

    },
    marginTop2: {
        marginTop: theme.spacing(2)
    },
    marginTop1: {
        marginTop: theme.spacing(1)
    },
    toggle: {
        "& .MuiToggleButton-root": {
            border: 0,
            color: theme.palette.text.primary,
            background: theme.palette.background.default,
            width: '100%',
            textTransform: 'capitalize',
            padding: '6px'
        },
        "& .Mui-selected": {
            backgroundColor: theme.palette.primary.main + ' !important',
            color: 'white',
            fontWeight: 600
        }
    },
})
const useOptions = () => {
    const options = {
        style: {
            base: {
                fontSize: '16px',
                color: "#424770",
                letterSpacing: "0.025em",
                fontFamily: "Source Code Pro, monospace",
                "::placeholder": {
                    color: "#aab7c4"
                }
            },
            invalid: {
                color: "#9e2146"
            }
        }
    }

    return options;
};

function genHex(n=16){ return [...crypto.getRandomValues(new Uint8Array(n))]
  .map(b=>b.toString(16).padStart(2,"0")).join(""); }

const PaymentForm = ({ registerFormValues, additionalInfo, answers, classes, enqueueSnackbar, resetFn, regTitle, membershipRegs, selectedRegistrationMeta }) => {
    const stripe = useStripe();
    const elements = useElements();
    const options = useOptions();
    const [clicked, setClicked] = useState(false);
    const [subscriptionType, setSubscriptionType] = useState('Autopay')
    const [contractTerms, setContractTerms] = useState(undefined)
    const [calendarsAndRolesToAdd, setCalendarsAndRolesToAdd] = useState([])
    const [billingInterval, setBillingInterval] = useState('')
    const dispatch = useDispatch()
    const [payType, setPayType] = useState('creditcard')
    const [linkToken, setLinkToken] = useState(null)
    const [bankAccountToken, setBankAccountToken] = useState(null)
    const [signUrl, setSignUrl] = useState(null);
    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState(null);
    const frameRef = useRef(null);
    const [creditCardComplete, setCreditCardComplete] = useState(false)
    const [iframeLoaded, setIframeLoaded] = useState(false)
    const [isAddOn, setIsAddOn] = useState(false)

    const nonce = useMemo(() => genHex(), []);
    const sid   = useMemo(() => crypto.randomUUID(), []);

    useEffect(() => {
            window.addEventListener("message", onMessage);
            return () => window.removeEventListener("message", onMessage);
    }, [nonce]);

    const handleIframeLoad = () => {
        setIframeLoaded(true);
    };

    const onMessage = (ev) => {
        initiateRegMetaInfo()
        if (ev.origin !== window.location.origin) return;
        const msg = ev.data || {};
        
        if (msg.nonce !== nonce) return;               
        if (!msg.sid || msg.sid !== sid) return;
        if(!msg.subscriptionType) return;

        setSubscriptionType(msg.subscriptionType)
        setPayType(msg.payType)
    
        if(msg.type === "DOCUSIGN_DONE" && msg.event === 'signing_complete'){
            createMembership(msg.subscriptionType, msg.payType, msg.token )
        }else{
            
            setSignUrl(null);
            setLoading(false);
            setClicked(false)
            setErrorMsg(`Incomplete contract, please try again`)
        }
    }

    useEffect(() => {
        window.scrollTo(0, 0)
        const tempUserId = +new Date() + '_' + registerFormValues.name;
        dispatch(getLinkAccountToken(tempUserId, null ,  (err, data) => {
            if (!err) {
                setLinkToken(data.data.link_token)
            }
        }))

        initiateRegMetaInfo()

    }, [])

    const initiateRegMetaInfo = () => {
         if(regTitle === 'Full Golf Membership'){
            setContractTerms('1 year term - Golf')
        }else if(regTitle === 'Social Membership'){
            setContractTerms('1 year term - Social')
        }else{
            setIsAddOn(true)
        }
        if (selectedRegistrationMeta && selectedRegistrationMeta._id) {
            dispatch(getRegistrationCalendarAndAssociatedRole(selectedRegistrationMeta._id, (err, resp) => {
                if (!err) {
                    setCalendarsAndRolesToAdd(resp.data.data)
                }
            }))

            if (selectedRegistrationMeta.billingInterval) {

                if (selectedRegistrationMeta.billingInterval == "day") {
                    setBillingInterval('daily')
                }
                if (selectedRegistrationMeta.billingInterval == "month") {
                    setBillingInterval('monthly')
                }
                if (selectedRegistrationMeta.billingInterval == "week") {
                    setBillingInterval('weekly')
                }

                if (selectedRegistrationMeta.billingInterval_count && selectedRegistrationMeta.billingInterval_count != 1) {

                    if (selectedRegistrationMeta.billingInterval_count == 3) {
                        setBillingInterval('every 3 months')
                    }

                    if (selectedRegistrationMeta.billingInterval_count == 6) {
                        setBillingInterval('every 6 months')
                    }

                    if (selectedRegistrationMeta.billingInterval_count == 12) {
                        setBillingInterval('yearly')
                    }

                }

            }

        }
    }


    const validateEmail = (email) => {
        const regexp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return regexp.test(email);
    }
    const handleSubscriptionTypeChange = (e) => {
        setSubscriptionType(e.target.value)
    }

    const updateInfoForPaperMembers = (loginToken, userIdToUpdate, isNoPayFirstTimeMember, emailToSave) => {

        var addObj = { ...additionalInfo };
        addObj.allcalUserId = userIdToUpdate;
        dispatch(updateInfoForPaperMember(addObj, loginToken, isNoPayFirstTimeMember, emailToSave, ()=>{}))

    }
   
    const onPaySelect = (val) => {
        setPayType(val)
        setCreditCardComplete(false)
    }

    const getRegType = (regTitle) => {
         if(regTitle === 'Full Golf Membership'){
            return 'Golf'
        }else if(regTitle === 'Social Membership'){
            return 'Social'
        }else if(regTitle === 'Golf Add-on Membership'){
            return 'Golf Add-on'
        }else if (regTitle === 'Social Add-on Membership'){
            return 'Social Add-on'
        }
        return ''
    }

    const isAddOnFn = (regTitle) => {
        // This is fragile - temporary - all of the text based checks
        return (regTitle === 'Golf Add-on Membership' || regTitle === 'Social Add-on Membership')
    }

    const dispatchSubscriptionWithBankToken = (bankToken, contractTerm) => {

        dispatch(signUp(registerFormValues, (error, registerResponse) => {

            if (!error) {

                dispatch(signIn(registerFormValues, (error, loginResponse) => {
                    if (!error) {
                        dispatch(subscribeWithBankToken(loginResponse.loginToken, selectedRegistrationMeta._id, bankToken, selectedRegistrationMeta.paymentType, contractTerm, (error, subscribeResp) => {
                            if (!error) {

                                updateInfoForPaperMembers(loginResponse.loginToken, loginResponse.userId, undefined, undefined)

                                dispatch(addMember(loginResponse.loginToken, registerResponse.userId, () => {
                                    const { myAccountBaseUrl, SENDGRID_WELCOME_TEMPLATE } = constants;

                                    let messageInfo = {};
                                    messageInfo.email = registerFormValues.email;
                                    messageInfo.name = registerFormValues.name;
                                    messageInfo.subject = registerFormValues.name + ' registered for ' + selectedRegistrationMeta.registrationTitle;
                                    messageInfo.message = 'Yay! New member signed up from Tanglewood website';
                                    messageInfo.type = getRegType(regTitle)
                                    messageInfo.url = myAccountBaseUrl
                                    messageInfo.showButton = (messageInfo.type === 'Golf' || messageInfo.type === 'Social')
                                    
                                    dispatch(welcomeUser(messageInfo, SENDGRID_WELCOME_TEMPLATE, () => { 
                                        dispatch(notifyOrganizer(messageInfo, () => { 

                                            if(isAddOnFn(regTitle)){
                                                dispatch(logInvitedMember(undefined, registerFormValues.email, messageInfo.type, selectedRegistrationMeta._id, 'accepted', ()=> {}))
                                            }
                                    
                                            for (var i = 0; i < Object.keys(answers).length; i++) {
                                            dispatch(saveAnswers(loginResponse.loginToken, selectedRegistrationMeta._id, Object.keys(answers)[i], answers[Object.keys(answers)[i]], (err) => {
                                            
                                                }))
                                            }
                                            for (var j = 0; j < calendarsAndRolesToAdd.length; j++) {
                                                dispatch(addAllcalMemberToCalendarWithDashboardRole(loginResponse.loginToken, calendarsAndRolesToAdd[j].calendarId, calendarsAndRolesToAdd[j].roleId, () => {

                                                }))
                                            }
                                            window.location.reload()
                                        }))
                                        
                                    }))
                                    
                                }))
                            }
                        }))
                    }

                }))

            } else {
                enqueueSnackbar(error, { variant: 'error', autoHideDuration: 3000 });
            }
        }))

    }


    const dispatchSubscription = (token, contractTerm) => {

        dispatch(signUp(registerFormValues, (error, registerResponse) => {

            if (!error) {

                dispatch(signIn(registerFormValues, (error, loginResponse) => {
                    if (!error) {
                        dispatch(subscribe(loginResponse.loginToken, selectedRegistrationMeta._id, token, selectedRegistrationMeta.paymentType, contractTerm, (error, subscribeResp) => {
                            if (!error) {

                                updateInfoForPaperMembers(loginResponse.loginToken, loginResponse.userId, undefined, undefined)

                                dispatch(addMember(loginResponse.loginToken, registerResponse.userId, () => {

                                    const { myAccountBaseUrl, SENDGRID_WELCOME_TEMPLATE } = constants;

                                    let messageInfo = {};
                                    messageInfo.email = registerFormValues.email;
                                    messageInfo.name = registerFormValues.name;
                                    messageInfo.subject = registerFormValues.name + ' registered for ' + selectedRegistrationMeta.registrationTitle;
                                    messageInfo.message = 'Yay! New member signed up from Tanglewood website';
                                    messageInfo.type = getRegType(regTitle)
                                    messageInfo.url = myAccountBaseUrl
                                    messageInfo.showButton = (messageInfo.type === 'Golf' || messageInfo.type === 'Social')

                                    
                                    dispatch(welcomeUser(messageInfo, SENDGRID_WELCOME_TEMPLATE, () => { 
                                         dispatch(notifyOrganizer(messageInfo, () => {

                                            if(isAddOnFn(regTitle)){
                                                dispatch(logInvitedMember(undefined, registerFormValues.email, messageInfo.type, selectedRegistrationMeta._id, 'accepted', ()=> {}))
                                            }
                                            for (var i = 0; i < Object.keys(answers).length; i++) {
                                                dispatch(saveAnswers(loginResponse.loginToken, selectedRegistrationMeta._id, Object.keys(answers)[i], answers[Object.keys(answers)[i]], (err) => {
                                                
                                                }))
                                            }

                                            for (var j = 0; j < calendarsAndRolesToAdd.length; j++) {
                                                dispatch(addAllcalMemberToCalendarWithDashboardRole(loginResponse.loginToken, calendarsAndRolesToAdd[j].calendarId, calendarsAndRolesToAdd[j].roleId, () => {

                                                }))
                                            }
                                            
                                            window.location.reload()
                                         }))
                                    }))
                                   
                                
                                    

                                }))


                            }
                        }))
                    }

                }))

            } else {
                enqueueSnackbar(error, { variant: 'error', autoHideDuration: 3000 });
            }
        }))

    }

    const handlePlaidBackAcctTokenCallback = (tokenObj, cb) => {
        if (tokenObj.stripe_bank_account_token) {
            setBankAccountToken(tokenObj.stripe_bank_account_token);
        }

    }

    const fetchPricing = (label) => {
        return `$${membershipRegs.find((reg) => reg.registrationTitle === constants.regNameDict[label])?.amountToRegister / 100}/month`
    }

    const fetchPrimaryMemberInfo = () => {
        return  answers[Object.keys(answers)[0]] || undefined
    }

    const beginSigning = () => {

        setLoading(true);
        setErrorMsg(null);

        const returnUrl =
        `${window.location.origin}/#/docusign-bridge` +
        `?nonce=${encodeURIComponent(nonce)}` +
        `&sid=${encodeURIComponent(sid)}` + 
        `&subscriptionType=${encodeURIComponent(subscriptionType)}` +
        `&payType=${encodeURIComponent(payType)}` +
        `&token=${bankAccountToken}`

        const { DOCUSIGN_CLIENT_USER_ID, DOCUSIGN_TEMPLATE_ID, DOCUSIGN_TEMPLATE_ID_ADD_ONS } = constants;
        const templateId = isAddOn ? DOCUSIGN_TEMPLATE_ID_ADD_ONS : DOCUSIGN_TEMPLATE_ID
        
        const pricing = {}
        pricing.golf = fetchPricing('GOLF')
        pricing.social = fetchPricing('SOCIAL')
        pricing.golf_addon = fetchPricing('GOLF_ADD_ON')
        pricing.social_addon = fetchPricing('SOCIAL_ADD_ON')

        const primaryMember = fetchPrimaryMemberInfo()
        try {

            const prefill = {"phone_field": additionalInfo.phoneNumber, 
                "dob_field": moment(additionalInfo.dateOfBirth).format('MM/DD/yyyy'), 
                "emergency_contact_field": additionalInfo.emergencyContactName,
                "emergency_contact_phone": additionalInfo.emergencyContact,
                "pob_field": additionalInfo.pob,
                "membership_field": regTitle,
                "home_address_field": additionalInfo.address,
                "mailing_address_field": additionalInfo.mailingAddress,
                "initiation_fee_golf": constants.initiation_fee.golf,
                "initiation_fee_social": constants.initiation_fee.social,
                "member_dues_golf": pricing.golf,
                "member_dues_social": pricing.social,
                "golf_add_on": pricing.golf_addon,
                "social_add_on": pricing.social_addon,
                "primary_member_name_field": primaryMember || registerFormValues.name
            }
            const signer = { "name": registerFormValues.name, "email": registerFormValues.email, "roleName": "Member", "clientUserId": "s1-embed" }

            dispatch(embeddedUrl(DOCUSIGN_CLIENT_USER_ID, templateId, signer, prefill, returnUrl, (err, payload) => {

                if(!err && payload.data){
                    setSignUrl(payload.data.url);
                }
                setLoading(false);
            }))
        
        } catch (e) {
         setErrorMsg(e?.message || "Failed to start signing");
         setLoading(false);
        } 
    }

    const createMembership = async (subType, payTypeVal, bankToken) => {
        
        let contractTerm; 
        if(regTitle === 'Full Golf Membership'){
            contractTerm = '1 year term - Golf'
        }else if(regTitle === 'Social Membership'){
            contractTerm = '1 year term - Social'
        }

        if (clicked) {
            return;
        }
        setClicked(true);

        if (selectedRegistrationMeta.includePayment && selectedRegistrationMeta.amountToRegister > 0) {
            if (subType === 'Autopay') {
                if (payTypeVal === 'ACH') {
                    if (!bankToken) {
                        setClicked(false);
                        setSignUrl(null);
                        setLoading(false);
                        setErrorMsg('Server error, please try after some time')
                        enqueueSnackbar('Server error, please try after some time', { variant: 'error', autoHideDuration: 3000 });
                        return;
                    } else {
                       dispatchSubscriptionWithBankToken(bankToken, contractTerm)
                    }
                } else {
                    if (!stripe || !elements) {
                        return;
                    }

                    const card = elements.getElement(CardElement);
                    const extraDetails = {
                        name: registerFormValues.name
                    }

                    const result = await stripe.createToken(card, extraDetails);

                    if (result.error) {
                        setClicked(false);
                        setSignUrl(null);
                        setLoading(false);
                        setErrorMsg(result.error.message)
                        enqueueSnackbar(result.error.message, { variant: 'error', autoHideDuration: 3000 });
                    } else {
                        dispatchSubscription(result.token, contractTerm)
                    }
                }
            } else {
                dispatchSubscription(undefined, contractTerm)
            }
        } 

    };

    return (
        <div>
            <form noValidate autoComplete="off">
                <Paper className={classnames(classes.marginTop1, classes.padding2, classes.bgTransparent)}>
                    <Grid container justify="space-between" alignItems="baseline" style={{ marginBottom: '24px' }}>
                        <Grid item >
                            <Button variant='outlined' onClick={resetFn} >Back</Button>
                        </Grid>
                        <Grid item>
                            <div className={classes.header}>{regTitle}</div>
                        </Grid>
                    </Grid>

                    <Grid container direction="column"  >
                        <Grid item style={{ fontSize: '18px', fontWeight: 600, marginBottom: '8px' }} >Choose Subscription Type</Grid>
                        <Grid item>
                            <RadioGroup onChange={handleSubscriptionTypeChange} name="Subscription Type" value={subscriptionType} row>
                                <FormControlLabel disabled={signUrl} value='Autopay' control={<Radio color="primary" />} label="Autopay monthly" />
                                <FormControlLabel disabled={signUrl} value='Paybyinvoice' control={<Radio color="primary" />} label="Pay monthly by e-invoice" />
                            </RadioGroup>
                        </Grid>
                        <Grid item>
                            <div style={{ fontSize: '14px' }}>
                                {
                                    subscriptionType === 'Autopay' ? <span> Card or Bank Account on file will be charged automatically every billing cycle</span>
                                        : <span>You will be sent an e-payment link over email every billing cycle</span>

                                }
                            </div>

                        </Grid>
                    </Grid>
                    
                    <Divider style={{ marginTop: '24px', marginBottom: '16px' }}></Divider>
                                
                    {/* HotFix: Until we rollout ACH upgrade */}
                    {/*subscriptionType === 'Autopay' && <Grid container>
                        <Grid item xs className={classnames(classes.headerDiv)}> Choose a Payment method </Grid>
                    </Grid>*/}

                    {/*subscriptionType === 'Autopay' && <Grid container >
                        <Grid item xs="12">
                            <Paper><div className={classes.toggle}><ToggleButton yesValue="creditcard" noValue="ACH" yesLabel="credit card" noLabel="Bank account" value={"creditcard"} onSelect={onPaySelect}></ToggleButton></div></Paper>
                        </Grid>
                    </Grid>*/}


                   <Grid container justify="space-between">
                        <Grid item>Registration Fee</Grid>
                        {selectedRegistrationMeta && <Grid item style={{ fontWeight: 600 }} >${selectedRegistrationMeta.amountToRegister / 100}  {billingInterval} </Grid>}
                    </Grid> 
                    <Grid container justify="space-between">
                        <Grid item>Tax</Grid>
                        {selectedRegistrationMeta && <Grid item>${parseFloat((selectedRegistrationMeta.amountToRegister / 100 * selectedRegistrationMeta.taxPercent / 100).toFixed(2))}</Grid>}
                    </Grid>

                    {
                        selectedRegistrationMeta && contractTerms && contractTerms === '1 year term - Golf' && <Grid container justify="space-between">
                            <Grid item>Initiation Fee (one time) </Grid>
                            {selectedRegistrationMeta && <Grid item >$3000 </Grid>}
                        </Grid>
                    }
                    {
                        selectedRegistrationMeta && contractTerms && contractTerms === '1 year term - Social' && <Grid container justify="space-between">
                            <Grid item>Initiation Fee (one time)</Grid>
                            {selectedRegistrationMeta && <Grid item >$1000 </Grid>}
                        </Grid>
                    }

                    {   
                        selectedRegistrationMeta && contractTerms && contractTerms === '2 year term - Golf' && <Grid container justify="space-between">
                            <Grid item>Initiation Fee (one time) </Grid>
                            {selectedRegistrationMeta && <Grid item >$2000 </Grid>}
                        </Grid>
                    }
                    {
                        selectedRegistrationMeta && contractTerms && contractTerms === '2 year term - Social' && <Grid container justify="space-between">
                            <Grid item>Initiation Fee (one time)</Grid>
                            {selectedRegistrationMeta && <Grid item >$1000 </Grid>}
                        </Grid>
                    }

                    {   
                        selectedRegistrationMeta && contractTerms && contractTerms === '3 year term - Golf' && <Grid container justify="space-between">
                            <Grid item>Initiation Fee (one time) </Grid>
                            {selectedRegistrationMeta && <Grid item >$1000 </Grid>}
                        </Grid>
                    }
                    {
                        selectedRegistrationMeta && contractTerms && contractTerms === '3 year term - Social' && <Grid container justify="space-between">
                            <Grid item>Initiation Fee (one time)</Grid>
                            {selectedRegistrationMeta && <Grid item >$500 </Grid>}
                        </Grid>
                    }

{   
                        selectedRegistrationMeta && contractTerms && contractTerms === '3 year term - Golf - no inititation fee offer' && <Grid container justify="space-between">
                            <Grid item>Initiation Fee (one time) </Grid>
                            {selectedRegistrationMeta && <Grid item > $0 </Grid>}
                        </Grid>
                    }
                    {
                        selectedRegistrationMeta && contractTerms && contractTerms === '3 year term - Social - no inititation fee offer' && <Grid container justify="space-between">
                            <Grid item>Initiation Fee (one time)</Grid>
                            {selectedRegistrationMeta && <Grid item >$0 </Grid>}
                        </Grid>
                    }

                    <Grid container justify="space-between" className={classes.marginTop2}>
                        {selectedRegistrationMeta && contractTerms && (contractTerms === '1 year term - Golf' || contractTerms === '1 year term - Social' || contractTerms === '2 year term - Golf' || contractTerms === '2 year term - Social' || contractTerms === '3 year term - Golf' || contractTerms === '3 year term - Social' || contractTerms === '3 year term - Golf - no inititation fee offer' || contractTerms === '3 year term - Social - no inititation fee offer') && < Grid item style={{ fontSize: '18px', fontWeight: 600 }}>Due {subscriptionType === 'Autopay' && ' Now' }</Grid>}
                        {selectedRegistrationMeta && contractTerms && contractTerms === '1 year term - Golf' && < Grid item style={{ fontSize: '18px', fontWeight: 600 }}>${parseFloat((selectedRegistrationMeta.amountToRegister / 100 * selectedRegistrationMeta.taxPercent / 100).toFixed(2)) + parseFloat((selectedRegistrationMeta.amountToRegister / 100).toFixed(2)) + 3000} </Grid>}
                        {selectedRegistrationMeta && contractTerms && contractTerms === '1 year term - Social' && < Grid item style={{ fontSize: '18px', fontWeight: 600 }}>${parseFloat((selectedRegistrationMeta.amountToRegister / 100 * selectedRegistrationMeta.taxPercent / 100).toFixed(2)) + parseFloat((selectedRegistrationMeta.amountToRegister / 100).toFixed(2)) + 1000}</Grid>}

                        {selectedRegistrationMeta && contractTerms && contractTerms === '2 year term - Golf' && < Grid item style={{ fontSize: '18px', fontWeight: 600 }}>${parseFloat((selectedRegistrationMeta.amountToRegister / 100 * selectedRegistrationMeta.taxPercent / 100).toFixed(2)) + parseFloat((selectedRegistrationMeta.amountToRegister / 100).toFixed(2)) + 2000} </Grid>}
                        {selectedRegistrationMeta && contractTerms && contractTerms === '2 year term - Social' && < Grid item style={{ fontSize: '18px', fontWeight: 600 }}>${parseFloat((selectedRegistrationMeta.amountToRegister / 100 * selectedRegistrationMeta.taxPercent / 100).toFixed(2)) + parseFloat((selectedRegistrationMeta.amountToRegister / 100).toFixed(2)) + 500}</Grid>}

                        {selectedRegistrationMeta && contractTerms && contractTerms === '3 year term - Golf' && < Grid item style={{ fontSize: '18px', fontWeight: 600 }}>${parseFloat((selectedRegistrationMeta.amountToRegister / 100 * selectedRegistrationMeta.taxPercent / 100).toFixed(2)) + parseFloat((selectedRegistrationMeta.amountToRegister / 100).toFixed(2)) + 1000} </Grid>}
                        {selectedRegistrationMeta && contractTerms && contractTerms === '3 year term - Social' && < Grid item style={{ fontSize: '18px', fontWeight: 600 }}>${parseFloat((selectedRegistrationMeta.amountToRegister / 100 * selectedRegistrationMeta.taxPercent / 100).toFixed(2)) + parseFloat((selectedRegistrationMeta.amountToRegister / 100).toFixed(2)) + 500}</Grid>}

                        {selectedRegistrationMeta && contractTerms && contractTerms === '3 year term - Golf - no inititation fee offer' && < Grid item style={{ fontSize: '18px', fontWeight: 600 }}>${parseFloat((selectedRegistrationMeta.amountToRegister / 100 * selectedRegistrationMeta.taxPercent / 100).toFixed(2)) + parseFloat((selectedRegistrationMeta.amountToRegister / 100).toFixed(2)) } </Grid>}
                        {selectedRegistrationMeta && contractTerms && contractTerms === '3 year term - Social - no inititation fee offer' && < Grid item style={{ fontSize: '18px', fontWeight: 600 }}>${parseFloat((selectedRegistrationMeta.amountToRegister / 100 * selectedRegistrationMeta.taxPercent / 100).toFixed(2)) + parseFloat((selectedRegistrationMeta.amountToRegister / 100).toFixed(2))}</Grid>}
                    </Grid>

                    {payType === 'creditcard' ? <Grid container alignItems="center" className={classes.marginTop2}>
                        {<Grid item xs="12" >

                            {subscriptionType === 'Autopay' ? <Paper style={{ padding: '12px', border: '1px solid #a4a6a7' }} className={classes.bgDefault}><CardElement
                                options={options}
                            
                                onChange={event => {
                                    setCreditCardComplete(false)
                                    if(event.complete && !event.error){
                                        setCreditCardComplete(true)
                                    }
                                }}
                               
                            />  </Paper> : <div></div>}


                        </Grid>}


                    </Grid> :
                        <Fragment>
                            {subscriptionType === 'Autopay' && <Grid container>
                                {!bankAccountToken ? <Grid item xs className={classes.marginTop2}>

                                    {linkToken && <Grid item xs><LinkAccountButton stripeUserInfoExists={true} disabled={true} token={linkToken} handleTokenCallback={handlePlaidBackAcctTokenCallback} label="Click To Link your bank account"></LinkAccountButton></Grid>}

                                </Grid> : <Grid container item justify="space-between" className={classes.marginTop1}>
                                    <Grid item>Payment method</Grid>
                                    <Grid item> Bank account  <AccountBalanceIcon color="primary"></AccountBalanceIcon></Grid>

                                </Grid>}

                            </Grid>
                            }
                        </Fragment>


                    }

                    <Grid container direction="column" justify="center" className={classes.marginTop2}>

                         <Grid item className={classes.marginTop2}>
                            
                            {!signUrl ? (<Fragment>
                                {<Button type="button" onClick={beginSigning}  fullWidth disabled={clicked || loading || (subscriptionType === 'Autopay' && ((payType === 'ACH' && !bankAccountToken) || (payType === 'creditcard' && !creditCardComplete )) )} variant="contained" size="large" name="TermsEsignBtn" color="primary" >
                                    {loading ? <span>Starting, please wait...<CircularProgress size={'14px'}></CircularProgress></span> : "Review and Complete Signup"}
                                </Button> }
                            
                                {errorMsg && <div style={{ color: "crimson" }}>{errorMsg}</div>}
                                <p style={{ fontSize: 12, color: "#666" }}>
                                    Please complete the e-sign process to become a member. Click to start signing.
                                </p>
                            </Fragment>) : (
                                <Fragment>
                                    {!iframeLoaded && <span>Prefilling details..<CircularProgress size={'14px'}></CircularProgress></span>}
                                     <iframe
                                    ref={frameRef}
                                    onLoad={handleIframeLoad}
                                    title="DocuSign Signing"
                                    src={signUrl}
                                    style={{ width: "100%", height: "90vh", border: 0 }}
                                    allow="clipboard-read; clipboard-write"
                                    />
                                </Fragment>
                               
                            )}
                        </Grid>
                    </Grid> 

                </Paper>
            </form >

        </div >
    );
};

export default withStyles(styles)(withSnackbar(PaymentForm));
